import { render } from "./TheAlarmGenerals.vue?vue&type=template&id=719b59ca"
import script from "./TheAlarmGenerals.vue?vue&type=script&lang=js"
export * from "./TheAlarmGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__